export const validateServiceBusString = (connectionString: string): boolean => {
  if (!connectionString || typeof connectionString !== "string") {
    return false;
  }

  const parts = connectionString.split(";");

  if (parts.length < 3) {
    return false;
  }

  const keyValueMap: Record<string, string> = {};
  parts.forEach((part) => {
    const [key, value] = part.split("=");
    if (key && value) {
      keyValueMap[key.trim()] = value.trim();
    }
  });

  if (
    !keyValueMap["Endpoint"] ||
    !keyValueMap["SharedAccessKeyName"] ||
    !keyValueMap["SharedAccessKey"]
  ) {
    return false;
  }

  if (!keyValueMap["Endpoint"].startsWith("sb://")) {
    return false;
  }

  return true;
};

export type SupportedTypes =
  "string" | "number" | "integer" | "int32" | "double" | "boolean" | "uuid" | "date" | "email";

export function validateValue(value: any, type: SupportedTypes): boolean {
  switch (type.toLowerCase()) {
    case "string":
      return typeof value === "string";

    case "number":
    case "double":
    case "int32":
      return typeof value === "number" && !isNaN(value);

    case "integer":
      return typeof value === "number" && Number.isInteger(value) && !isNaN(value);

    case "boolean":
      return typeof value === "boolean";

    case "uuid":
      return (
        typeof value === "string" &&
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)
      );

    case "date":
      return (
        (value instanceof Date && !isNaN(value.getTime())) ||
        (typeof value === "string" && !isNaN(new Date(value).getTime()))
      );

    case "email":
      return typeof value === "string" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    default:
      throw new Error(`Unsupported type: ${type}`);
  }
}
